// import { defineStore } from 'pinia'

// export const useSetWaypointsState = defineStore('setWayPointsState', {
//   state: () => ({
//     home: {
//       missionName: '',
//       aircraft: '',
//       altitudeMode: '',
//       showWaypointNum: false,
//       showWaypointAltitude: false,
//       showWaypointDistance: false,
//       payload1: '',
//       payload2: '',
//       payload3: ''
//     },
//     flightPlanning: {
//       savePhoto: [],
//       smartLowLight: false,
//       safeTakeOffAltitude: 20,
//       climbToStartPoint: false,
//       speed: 5,
//       relativeAltitude: 100,
//       aircraftYaw: 'Along the Route',
//       gimbalControl: 'manual',
//       waypointType: 'Straight route. Aircraft stops',
//       uponCompletion: 'Return to Home',
//       takeoffSpeed: 15
//     },
//     waypointAction: {
//       speed: 0,
//       relativeAltitude: '',
//       aircraftYaw: 0,
//       aircraftRotation: 0,
//       waypointType: '',
//       gimbalPitch: 0,
//       followRoute: {
//         speed: true,
//         relativeAltitude: true,
//         aircraftYaw: true,
//         aircraftRotation: true,
//         waypointType: true
//       },
//       latitude: 0,
//       longitude: 0,
//       actions: {
//         payloadActions: [],
//         aircraftActions: []
//       }
//     },
//     waypointsDetails: [

//     ],
//     distance: []
//   }),
//   actions: {
//     setWaypointsDetails (details) {
//       this.waypointsDetails = details
//     }
//   }
// })

import { defineStore } from 'pinia'

export const useSetWaypointsState = defineStore('setWaypointsState', {
  state: () => ({
    waypointsDetails: [],
    flightPlanning: {
      safeTakeOffAltitude: 120,
      speed: 5,
      relativeAltitude: 100,
      aircraftYaw: 'Along the Route',
      gimbalControl: 'manual',
      waypointType: 'Coordinated Turn. Skips waypoints',
      uponCompletion: 'Return to Home',
      takeoffSpeed: 5,
      smartLowLight: false,
      climbToStartPoint: false,
      savePhoto: [],
      droneEnumValue: '',
      droneSubEnumValue: 0,
      altitudeMode: '',
      // M4T thermal mission params (WPML extension, ignored by non-thermal drones)
      thermalEnabled: false,
      thermalPaletteStyle: 0,
      thermalGainMode: 0,
      thermalIsothermEnabled: false,
      thermalIsothermUpperLimit: null,
      thermalIsothermLowerLimit: null
    },
    waypointAction: {
      followRoute: {
        speed: false,
        relativeAltitude: false,
        aircraftYaw: false,
        aircraftRotation: false,
        waypointType: false
      }
    },
    distance: [],
    // NEW: Edit mode properties
    isEditMode: false,
    editingPlanningId: null,
    originalData: null
  }),

  actions: {
    // NEW: Set planning data for editing
    setPlanningData (planningData) {
      if (planningData.waypointsDetails) {
        this.waypointsDetails = planningData.waypointsDetails
      }

      if (planningData.flightPlanning) {
        this.flightPlanning = { ...this.flightPlanning, ...planningData.flightPlanning }
      }

      if (planningData.waypointAction) {
        this.waypointAction = { ...this.waypointAction, ...planningData.waypointAction }
      }

      if (planningData.distance) {
        this.distance = planningData.distance
      }

      this.isEditMode = true
      this.editingPlanningId = planningData.id
      this.originalData = JSON.parse(JSON.stringify(planningData))
    },

    // NEW: Reset to create new planning
    resetForNewPlanning () {
      this.waypointsDetails = []
      this.flightPlanning = {
        safeTakeOffAltitude: 120,
        speed: 5,
        relativeAltitude: 100,
        aircraftYaw: 'Along the Route',
        gimbalControl: 'manual',
        waypointType: 'Coordinated Turn. Skips waypoints',
        uponCompletion: 'Return to Home',
        takeoffSpeed: 5,
        smartLowLight: false,
        climbToStartPoint: false,
        savePhoto: [],
        thermalEnabled: false,
        thermalPaletteStyle: 0,
        thermalGainMode: 0,
        thermalIsothermEnabled: false,
        thermalIsothermUpperLimit: null,
        thermalIsothermLowerLimit: null
      }
      this.waypointAction = {
        followRoute: {
          speed: false,
          relativeAltitude: false,
          aircraftYaw: false,
          aircraftRotation: false,
          waypointType: false
        }
      }
      this.distance = []
      this.isEditMode = false
      this.editingPlanningId = null
      this.originalData = null
    },

    // NEW: Parse wayline data from API response
    parseWaylineData (waylineData) {
      console.log('waylineDtaa:', waylineData)
      try {
        const kmlData = waylineData.kml?.Document
        const wpmlData = waylineData.wpml?.Document

        if (!kmlData && !wpmlData) {
          console.error('Invalid wayline data structure')
          return
        }

        // Extract mission config
        const missionConfig = kmlData?.missionConfig || wpmlData?.missionConfig
        if (missionConfig) {
          if (missionConfig.takeOffSecurityHeight?.takeOffSecurityHeight) {
            this.flightPlanning.safeTakeOffAltitude = parseInt(missionConfig.takeOffSecurityHeight.takeOffSecurityHeight)
          }

          if (missionConfig.globalTransitionalSpeed?.globalTransitionalSpeed) {
            this.flightPlanning.speed = parseFloat(missionConfig.globalTransitionalSpeed.globalTransitionalSpeed)
          }

          if (missionConfig.droneInfo.droneEnumValue?.droneEnumValue) {
            this.flightPlanning.droneEnumValue = missionConfig.droneInfo.droneEnumValue.droneEnumValue
          }
          if (missionConfig.droneInfo.droneSubEnumValue?.droneSubEnumValue !== undefined) {
            this.flightPlanning.droneSubEnumValue = missionConfig.droneInfo.droneSubEnumValue.droneSubEnumValue
          }
        }

        // Extract waypoints from Placemark
        const placemarks = kmlData?.Folder?.Placemark || wpmlData?.Folder?.Placemark || []
        this.waypointsDetails = this.parsePlacemarksToWaypoints(placemarks)

        // Extract template configuration
        const folder = kmlData?.Folde
        if (folder) {
          if (folder.globalHeight?.globalHeight) {
            this.flightPlanning.relativeAltitude = parseFloat(folder.globalHeight.globalHeight)
          }

          if (folder.autoFlightSpeed?.autoFlightSpeed) {
            this.flightPlanning.speed = parseFloat(folder.autoFlightSpeed.autoFlightSpeed)
          }

          if (folder.gimbalPitchMode?.gimbalPitchMode) {
            this.flightPlanning.gimbalControl = folder.gimbalPitchMode.gimbalPitchMode
          }

          if (folder.globalWaypointHeadingParam?.waypointHeadingMode?.waypointHeadingMode) {
            this.flightPlanning.aircraftYaw = this.mapHeadingModeToYaw(folder.globalWaypointHeadingParam.waypointHeadingMode.waypointHeadingMode)
          }

          if (folder.globalWaypointTurnMode?.globalWaypointTurnMode) {
            this.flightPlanning.waypointType = this.mapTurnModeToType(folder.globalWaypointTurnMode.globalWaypointTurnMode)
          }
        }

        const folder2 = wpmlData?.Folder
        if (folder2) {
          if (folder2?.executeHeightMode?.executeHeightMode) {
            console.log('enter in executeMode')
            this.flightPlanning.altitudeMode = folder2.executeHeightMode.executeHeightMode
          }
        }

        this.isEditMode = true
        console.log('Parsed wayline data successfully for editing')
      } catch (error) {
        console.error('Error parsing wayline data:', error)
      }
    },

    // Parse placemarks to waypoints format
    parsePlacemarksToWaypoints (placemarks) {
      console.log('placemarks:', placemarks)
      return placemarks.map((placemark, index) => {
        // ✅ RC coordinates come as "longitude,latitude" string
        const coordString = placemark.Point?.coordinates?.coordinates || '0,0'
        const [rcLon, rcLat] = coordString.split(',').map(Number)

        console.log(`Parsing placemark ${index}: RC string "${coordString}" -> [lon:${rcLon}, lat:${rcLat}]`)

        // ✅ STORE IN RC FORMAT: latitude field gets longitude value
        return {
          waypointAction: {
            latitude: rcLon, // Store RC's longitude in latitude field
            longitude: rcLat, // Store RC's latitude in longitude field
            relativeAltitude: parseFloat(placemark.ellipsoidHeight?.ellipsoidHeight || placemark.executeHeight?.executeHeight || 100),
            speed: parseFloat(placemark.waypointSpeed?.waypointSpeed || 5),
            aircraftYaw: this.mapHeadingModeToYaw(placemark.waypointHeadingParam?.waypointHeadingMode?.waypointHeadingMode),
            waypointType: this.mapTurnModeToType(placemark.waypointTurnParam?.waypointTurnMode?.waypointTurnMode),
            gimbalPitch: placemark.gimbalPitchAngle?.gimbalPitchAngle || 0,
            followRoute: {
              speed: placemark.useGlobalSpeed?.useGlobalSpeed === '1',
              relativeAltitude: placemark.useGlobalHeight?.useGlobalHeight === '1',
              aircraftYaw: placemark.useGlobalHeadingParam?.useGlobalHeadingParam === '1',
              waypointType: placemark.useGlobalTurnParam?.useGlobalTurnParam === '1'
            }
          },
          actionsSelected: this.parseActionsFromPlacemark(placemark),
          selectedActions: this.parseSelectedActions(placemark)
        }
      })
    },

    // Map heading mode to aircraft yaw
    mapHeadingModeToYaw (headingMode) {
      const mapping = {
        followWayline: 'Along the Route',
        manual: 'Manual',
        lockYawAxis: 'Lock Yaw Axis',
        smoothTransition: 'Auto',
        faceForward: 'Face Forward',
        faceHome: 'Face Home'
      }
      return mapping[headingMode] || 'Along the Route'
    },

    // Map turn mode to waypoint type
    mapTurnModeToType (turnMode) {
      const mapping = {
        coordinateTurn: 'Coordinated Turn. Skips waypoints',
        toPointAndStop: 'Straight route. Aircraft stops',
        toPointAndPassWithContinuityCurvature: 'Turns before waypoint. Files through',
        toPointAndStopWithDiscontinuityCurvature: 'Curved route. Aircraft stops',
        toPointAndPassWithDiscontinuityCurvature: 'Curved route. Aircraft continues'
      }
      return mapping[turnMode] || 'Coordinated Turn. Skips waypoints'
    },

    // Parse actions from placemark
    parseActionsFromPlacemark (placemark) {
      const actions = []
      const actionGroup = placemark.actionGroup

      if (!actionGroup) return actions

      // You can extend this based on your action mapping
      if (actionGroup.action?.actionActuatorFunc?.actionActuatorFunc === 'takePhoto') {
        actions.push({ type: 'payload', name: 'takeAPhoto' })
      }

      return actions
    },

    // Parse selected actions with values
    parseSelectedActions (placemark) {
      const selectedActions = {
        payloadActions: {},
        aircraftActions: {}
      }

      // You can extend this based on your actual action structure
      const actionGroup = placemark.actionGroup
      if (actionGroup && actionGroup.action) {
        // Parse gimbal rotations, zoom, etc.
        const actionParams = actionGroup.action.actionActuatorFuncParam
        if (actionParams) {
          if (actionParams.gimbalPitchRotateAngle) {
            selectedActions.payloadActions.gimbalPitchRotation = parseFloat(actionParams.gimbalPitchRotateAngle)
          }
          if (actionParams.gimbalYawRotateAngle) {
            selectedActions.payloadActions.gimbalYaw = parseFloat(actionParams.gimbalYawRotateAngle)
          }
        }
      }

      return selectedActions
    },

    // Check if there are changes
    hasChanges () {
      if (!this.isEditMode) return true

      const currentData = {
        waypointsDetails: this.waypointsDetails,
        flightPlanning: this.flightPlanning,
        waypointAction: this.waypointAction,
        distance: this.distance
      }

      return JSON.stringify(currentData) !== JSON.stringify(this.originalData)
    }
  }
})
